import approvalInput from './saveInputs/approvalInput';

export default (approval) => `
    saveDrugApprovalHistory (history: {
        ${approvalInput(approval)}
    }) {
        id
    }
`;
